import { Eye } from "lucide-react";
import { formatCount } from "@/lib/api";
import { usePlayer } from "@/contexts/PlayerContext";

export function ShortCard({ video }) {
  const { play } = usePlayer();
  return (
    <button
      type="button"
      onClick={() => play(video)}
      data-testid={`short-card-${video.video_id}`}
      className="block group relative aspect-[9/16] rounded-xl overflow-hidden bg-bg-surface animate-fade-up text-left w-full"
    >
      <img
        src={video.thumbnail}
        alt={video.title}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent" />
      <span className="absolute top-2 left-2 w-2 h-2 rounded-full bg-brand shadow-[0_0_8px_rgba(230,59,46,0.8)]" />
      <div className="absolute bottom-0 left-0 right-0 p-2 flex flex-col gap-1">
        <p className="text-[11px] font-medium line-clamp-2 leading-tight text-white/95">{video.title}</p>
        <div className="flex items-center gap-1 text-[10px] text-white/80">
          <Eye size={10} />
          <span>{formatCount(video.view_count)}</span>
        </div>
      </div>
    </button>
  );
}
